import { render, staticRenderFns } from "./Screens.vue?vue&type=template&id=e70cee86"
import script from "./Screens.vue?vue&type=script&lang=js"
export * from "./Screens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e70cee86')) {
      api.createRecord('e70cee86', component.options)
    } else {
      api.reload('e70cee86', component.options)
    }
    module.hot.accept("./Screens.vue?vue&type=template&id=e70cee86", function () {
      api.rerender('e70cee86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Screens.vue"
export default component.exports